import { useState, useEffect } from 'react';
import type { Notification } from '../types';
import {
  loadNotificationsFromStorage,
  markAsRead as serviceMarkAsRead,
  markAllAsRead as serviceMarkAllAsRead
} from '../services/notificationService';

export function useNotifications() {
  const [notifications, setNotifications] = useState<Notification[]>(() => loadNotificationsFromStorage());
  const [unreadCount, setUnreadCount] = useState(() => {
    const stored = loadNotificationsFromStorage();
    return stored.filter(n => !n.isRead).length;
  });

  useEffect(() => {
    // Подписываемся на глобальные обновления уведомлений
    const handleNotificationsUpdate = (event: Event) => {
      const customEvent = event as CustomEvent;
      const updatedNotifications = customEvent.detail.notifications;

      setNotifications(updatedNotifications);
      setUnreadCount(updatedNotifications.filter((n: Notification) => !n.isRead).length);
    };

    window.addEventListener('notificationsUpdated', handleNotificationsUpdate);

    return () => {
      window.removeEventListener('notificationsUpdated', handleNotificationsUpdate);
    };
  }, []);

  const markAsRead = (id: string) => {
    const updated = serviceMarkAsRead(id);
    setNotifications(updated);
    setUnreadCount(updated.filter(n => !n.isRead).length);
  };

  const markAllAsRead = () => {
    const updated = serviceMarkAllAsRead();
    setNotifications(updated);
    setUnreadCount(0);
  };

  const showSuccess = (message: string) => {
    // В реальном приложении здесь будет toast уведомление
    alert(`✅ ${message}`);
  };

  const showError = (message: string) => {
    // В реальном приложении здесь будет toast уведомление
    alert(`❌ ${message}`);
  };

  return {
    notifications,
    unreadCount,
    markAsRead,
    markAllAsRead,
    showSuccess,
    showError,
  };
}